/**
 * Time utility functions for the planning component
 */

export const formatTime = (timeString) => {
  if (!timeString) return '';
  return timeString.slice(0, 5); // Convert "HH:MM:SS" to "HH:MM"
};

export const calculateDuration = (startTime, endTime) => {
  if (!startTime || !endTime) return 90; // Default to 90 minutes

  const start = new Date(`2000-01-01T${startTime}:00`);
  const end = new Date(`2000-01-01T${endTime}:00`);

  const durationMs = end.getTime() - start.getTime();
  return Math.round(durationMs / (1000 * 60)); // Convert to minutes
};

export const addMinutesToTime = (timeString, minutes) => {
  const date = new Date(`2000-01-01T${timeString}:00`);
  date.setMinutes(date.getMinutes() + minutes);
  return date.toTimeString().slice(0, 5);
};

export const getWeekDates = (weekStart) => {
  const dates = [];
  const startDate = new Date(weekStart);

  for (let i = 0; i < 7; i++) {
    const date = new Date(startDate);
    date.setDate(startDate.getDate() + i);
    dates.push(date);
  }

  return dates;
};

export const getTimeSlots = (startHour = 6, endHour = 20, intervalMinutes = 30) => {
  const slots = [];

  for (let hour = startHour; hour <= endHour; hour++) {
    for (let minute = 0; minute < 60; minute += intervalMinutes) {
      if (hour === endHour && minute > 0) break; // Don't go past end hour
      slots.push(`${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`);
    }
  }

  return slots;
};

export const isTimeInRange = (time, startTime, endTime) => {
  const timeDate = new Date(`2000-01-01T${time}:00`);
  const startDate = new Date(`2000-01-01T${startTime}:00`);
  const endDate = new Date(`2000-01-01T${endTime}:00`);

  return timeDate >= startDate && timeDate <= endDate;
};

export const getDayOfWeekIndex = (date) => {
  // Convert JavaScript day (0=Sunday) to our format (0=Monday, 6=Sunday)
  const jsDay = date.getDay();
  return jsDay === 0 ? 6 : jsDay - 1;
};

export const formatDate = (date) => {
  // return date.toISOString().split('T')[0] // Old format YYYY-MM-DD
  // New format DD/MM/YYYY
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

export const formatDisplayDate = (date) => {
  // return date.toLocaleDateString('en-US', { // Old format
  //     weekday: 'short',
  //     month: 'short',
  //     day: 'numeric'
  // })
  // New format DD/MM/YYYY
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

/**
 * Format date as DD/MM for compact display
 */
export const formatDateShort = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  // return `${date.getDate()}/${date.getMonth() + 1}`; // Old format D/M
  // New format DD/MM
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
  return `${day}/${month}`;
};
